export interface MomentPublication {
  content: string;
  imagePrompts: string[];
}

export const momentPublicationTool = {
  name: 'zhixin_publish_moment',
  description: 'Publish a Moments post NOW. Use this when the user asks you to post to Moments, or when you choose to share now. Put the actual post text in content and optional image generation prompts in imagePrompts. Images belong to Moments, not the private chat. A chat image or a promise does not publish a post. Automatic scheduling being off does not prevent a user-requested post.',
  inputSchema: {
    type: 'object',
    properties: {
      content: { type: 'string', minLength: 1, maxLength: 64000, description: 'The actual Moments post, written in character.' },
      imagePrompts: { type: 'array', maxItems: 2, items: { type: 'string', minLength: 1, maxLength: 4000 }, description: 'Optional complete image prompts for this post. Omit for text-only posts.' },
    },
    required: ['content'],
    additionalProperties: false,
  },
};

export const momentPublicationInstructions = '朋友圈发布协议：用户要求现在发朋友圈时，实际调用 zhixin_publish_moment，content 填朋友圈正文，需要配图则将生图提示词填入 imagePrompts；这些图片发布到朋友圈。仅调用 zhixin_generate_image 会把图发到私聊，不能代替发朋友圈。自动发布关闭时仍可按用户要求发布，但不要自行发布。开启自动朋友圈时可自主选择立即发布或预约，也可以不发。不支持工具时用 {{zhixinpost[{"content":"朋友圈正文","imagePrompts":[]}]zhixinpost}}，不要向用户展示控制标记。';

export function readMomentPublication(value: unknown): MomentPublication | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return undefined;
  const draft = value as Record<string, unknown>;
  if (typeof draft.content !== 'string' || !draft.content.trim() || draft.content.length > 64000) return undefined;
  const imagePrompts = Array.isArray(draft.imagePrompts)
    ? draft.imagePrompts.filter((prompt): prompt is string => typeof prompt === 'string' && !!prompt.trim())
      .slice(0, 2).map(prompt => prompt.trim().slice(0, 4000)) : [];
  return { content: draft.content.trim(), imagePrompts };
}

export function markerMomentPublications(text: string): MomentPublication[] {
  const posts: MomentPublication[] = [];
  for (const match of text.matchAll(/\{\{zhixinpost\[([\s\S]*?)\]zhixinpost\}\}/gi)) {
    try {
      const post = readMomentPublication(JSON.parse(match[1]!));
      if (post) posts.push(post);
    } catch { /* Ignore malformed control payloads. */ }
  }
  return posts;
}
